import { ORTHO_ICD10, ORTHO_CPT } from '../data/orthoData';

export default function CodeBadge({ code, type, onRemove }) {
  const list = type === "icd10" ? ORTHO_ICD10 : ORTHO_CPT;
  const info = list.find(x => x.code === code);
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      background: type === "icd10" ? "#1a3a2a" : "#1a2a3a",
      border: `1px solid ${type === "icd10" ? "#2d6b4a" : "#2d4a6b"}`,
      color: type === "icd10" ? "#4ade80" : "#60a5fa",
      borderRadius: 6, padding: "2px 8px", fontSize: 11, fontFamily: "'IBM Plex Mono', monospace",
    }}>
      <span style={{ fontWeight: 700 }}>{code}</span>
      {info && <span style={{ opacity: 0.7, fontSize: 10 }}>· {info.desc.substring(0, 28)}{info.desc.length > 28 ? "…" : ""}</span>}
      <button onClick={() => onRemove(code)} style={{ background: "none", border: "none", color: "inherit", cursor: "pointer", opacity: 0.6, padding: "0 0 0 2px", fontSize: 12, lineHeight: 1 }}>×</button>
    </span>
  );
}
